export const PAGE_EXPLANATIONS: Record<string, string> = {
  User:
    "The raw User account record behind every office and Talent on the platform. Use it when you need the login-level account rather than the Talent or Location profile.",
  Talent:
    "Every dental professional on the platform. Pick a Talent to open their full profile, including identity and payouts, courses, jobs, feedback, notes, blocks and potential duplicates. The tabs switch between New Members Review, First Shift Booked and the complete Talent list.",
  BlockedHygienist:
    "Talent who have been blocked from a specific dental office. Each row is one Talent-to-Location block.",
  FavouriteHygienist:
    "Talent who have been marked as a favourite by a specific dental office. Each row is one Talent-to-Location favourite.",
  DentalOffices:
    "Every dental office location on the platform. Pick a Location to open its full profile, including associated locations, posted jobs, invoices, payments, placement fee history, cancellations, feedback, notes and admin actions.",
  BlockedDentist:
    "Dental offices that a Talent has blocked. Each row is one Location-to-Talent block.",
  FavouriteDentist:
    "Dental offices that a Talent has marked as a favourite. Each row is one Location-to-Talent favourite.",
  GeoViz:
    "Offices, Talent and shifts plotted on a map. Use the filters to narrow by entity type, role, region, shift status and date range, or to see the Talent landscape around a particular office.",
  DailyShiftList:
    "The shifts scheduled for each day, for a day-by-day view of what is booked across the platform.",
  Job:
    "Every job posted by a dental office. A job is the office's request; the shifts inside it are the individual working days.",
  Shift:
    "Every individual shift on the platform, with its job, status and times. All times displayed in Eastern Time (America/Toronto). EST/EDT is applied automatically.",
  Invoices:
    "Every invoice raised on the platform, with tabs for all, unresolved and resolved invoices. Open an invoice to see its details, payment status and notes.",
  RawData:
    "Direct table views for data that does not have its own page. Day-to-day work should happen on the Talent, Location and Invoice pages; use this when you need the underlying rows.",
  SNCBillingBoard:
    "Short-notice cancellations by dental offices that are waiting on a billing decision. Use it to charge or clear the short-notice cancellation fee.",
  SNCbyHygDa:
    "Short-notice cancellations by Talent. Review each one and award placement fee credit to the affected office where that is warranted.",
  ChatHistory:
    "The in-app messages between an office and a Talent for a given job. Enter a Job ID to read the conversation.",
  ManualShiftBooking:
    "Book a Talent onto a shift by hand on behalf of an office. Use only where the normal in-app booking flow cannot be used.",
  History:
    "A field-level change log for AP. Each row records which admin changed which column on which record, and what it changed from and to.",
  ReviewHistory:
    "A log of admin actions in AP. Each row records which admin used which button, against which Talent or office, and when. Use it to check what has already been actioned on an account.",
  EmailTracker:
    "Emails sent through Mandrill, searchable by recipient, subject or sender. Use it to confirm whether an email reached someone and whether they opened it. This is not bucket email."
};
